<style scoped lang="scss">

</style>
<template>
    <div class="container bg_fff">
        <breadcrumb :pages="['直播列表']"></breadcrumb>
        <div class="pl15 pr15 pt15 pb10">
            <el-table border size="mini" :data="list" :header-cell-style="{backgroundColor:'#fafafa'}">
                <el-table-column label="课程" prop="name"></el-table-column>
                <el-table-column label="主讲人" prop="doc"></el-table-column>
                <el-table-column label="开始时间" prop="start"></el-table-column>
                <el-table-column label="结束时间" prop="end"></el-table-column>
                <el-table-column label="sip设备" prop="sip"></el-table-column>
                <el-table-column label="房间号" prop="room"></el-table-column>
                <el-table-column label="操作" fixed="right" width="200px">
                    <template slot-scope="{row}">
                        <el-button size="mini" type="primary" @click="handler('console',row)">管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
  import Breadcrumb from "../../components/common/Breadcrumb";

  const list = [
    {
      name: '小暑到来，如何度过清凉一夏',
      doc: '何志明',
      start: '2019-07-10 18:00',
      end: '2019-07-10 19:00',
      room: 15015015000
    }
  ]


  export default {
    name: "List",
    components: {Breadcrumb},
    data() {
      return {
        list
      }
    },
    methods: {
      handler(type, data) {
        if (type === 'console') this.$router.push({
          path: '/other/live/console',
          query: {room: data.room}
        })
      }
    },
  }
</script>

